import React from "react";
import DateHelper from "../../DateHelper/DateHelper";
import { format } from "date-fns";

class RuTaskFrequencyDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.time_period && this.props.data.time_value ) {
      var { time_period, time_value } = this.props.data;

      if (time_period.includes("day")) {
        return (
          <div>
            {I18n.t("daily") +
              " at " +
              format(
                new Date(time_value),
                DateHelper.rubyToDateFNS(this.props.time_format)
              )}
          </div>
        );
      } else if (time_period.includes("month")) {
        return (
          <div>{I18n.t("monthly") + " on the " + this.props.data.time_value}</div>
        );
      } else if (time_period.includes("week")) {
        return (
          <div>{I18n.t("weekly") + " on " + this.props.data.time_value}</div>
        )
      } else {
        return <div>{I18n.t("every_quarter_hour")}</div>;
      }
    } else {
      return < div > { I18n.t("every_quarter_hour") }</div >;
    }
  }
}

export default RuTaskFrequencyDataType;
